import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_SIGN_TEMPLATE } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_SIGN_TEMPLATE
    }
};

export const signTemplateSlice = createSlice({
    name: 'signTemplate',
    initialState,
    reducers: {
        searchSignTemplate: (state, action) => {
            state.search = action.payload;
        },
        searchSignTemplatePageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = signTemplateSlice;
export const { searchSignTemplate, searchSignTemplatePageFirst } = actions

export const selectSearchSignTemplate = (state) => state?.features?.signTemplate?.search

export default reducer


